import styled, { css } from "styled-components";
import { numeric } from "../../../typography";
import { SPREAD_PAGE_VALUE } from "../pagination.utils";
import { PaginationTestIds } from "../Pagination";

const sharedStyles = css`
  ${numeric.primaryActive.subtitle2};
  border: none;
  background: none;
  min-width: 24px;
  user-select: none;
  font-weight: var(--font-weight-semibold);
`;

const PageContainer = styled.button`
  ${sharedStyles}
  color: var(--color-secondary-800);
  padding: 0;

  &:hover {
    color: var(--color-secondary-600);
    cursor: pointer;
  }
`;

const CurrentPage = styled.div`
  ${sharedStyles}
  padding: 0;
  user-select: none;
  text-align: center;
  color: var(--color-primary-600);
`;

const SpreadPage = styled.div`
  ${sharedStyles}
  color: var(--color-primary-200);
  font-weight: var(--font-weight-semibold);
  padding: 0;
  text-align: center;
  user-select: none;
  letter-spacing: 4px;
`;

type PageProps = {
  page: number;
  currentPage: number;
  testid?: string;
  handleOnChangePage: (page: number) => void;
};

export const Page = ({
  page,
  currentPage,
  testid,
  handleOnChangePage,
}: PageProps) => {
  if (page === SPREAD_PAGE_VALUE)
    return (
      <SpreadPage data-testid={PaginationTestIds.PageSpread}>...</SpreadPage>
    );
  if (page === currentPage)
    return <CurrentPage data-testid={testid}>{page}</CurrentPage>;

  return (
    <PageContainer
      data-testid={testid}
      onClick={() => handleOnChangePage(page)}
    >
      {page}
    </PageContainer>
  );
};
